var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookOrangeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13371",
    "data-name": "Group 13371",
    transform: "translate(-1482 -512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13234",
    "data-name": "Group 13234",
    transform: "translate(1482 512.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 -0.499)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 18,
    rx: 17.5,
    ry: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 18,
    rx: 17.375,
    ry: 17.875,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13347",
    "data-name": "Group 13347",
    transform: "translate(1486.438 516.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13345",
    "data-name": "Group 13345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420-2",
    "data-name": "Ellipse 420",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-0.438 0.064)",
    fill: "#3e78f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_45464",
    "data-name": "Path 45464",
    d: "M1531.42,5404.351l.459-3h-2.874v-1.944a1.5,1.5,0,0,1,1.689-1.618H1532v-2.55a15.949,15.949,0,0,0-2.32-.2,3.657,3.657,0,0,0-3.914,4.031v2.283h-2.632v3h2.632v7.24a10.312,10.312,0,0,0,3.239,0v-7.24Z",
    transform: "translate(-1514.26 -5390.603)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOrangeCircle);
export default __webpack_public_path__ + "static/media/facebook-orange-circle.cce04b839ca5458d0ed8d50c194b3c44.svg";
export { ForwardRef as ReactComponent };